import { render, staticRenderFns } from "./Four_boxgrid.vue?vue&type=template&id=74c2cffa&scoped=true"
import script from "./Four_boxgrid.vue?vue&type=script&lang=js"
export * from "./Four_boxgrid.vue?vue&type=script&lang=js"
import style0 from "./Four_boxgrid.vue?vue&type=style&index=0&id=74c2cffa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2cffa",
  null
  
)

export default component.exports